export default {
  namespaced: true,
  state: {
    darkMode: localStorage.getItem('darkMode') === 'true'
  },
  mutations: {
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode
      localStorage.setItem('darkMode', state.darkMode)
    }
  }
}